import React, { FC } from 'react';
import { SystemButtonDefault } from '../systemButtonDefaultProps';
import { SystemButtonProps } from '../button.types';
import styles from './secondary_button.module.scss';
import { BaseButton } from '../BaseButton';

export const SecondaryButton: FC<SystemButtonProps> = ({
  dataName,
  ...rest
}) => {
  return <BaseButton {...rest} className={styles.secondary} name={dataName} />;
};

SecondaryButton.defaultProps = SystemButtonDefault;
